const RECOVERY_BUTTON_SELECTOR = '[data-emergency-cache-recovery]'

/**
 * 清理当前前端站点可访问的数据。跨域 HttpOnly Cookie 无法由页面删除。
 */
export function clearAppSiteData() {
  try {
    window.localStorage.clear()
  } catch (error) {
    console.warn('[Cache Recovery] localStorage 清理失败', error)
  }

  try {
    window.sessionStorage.clear()
  } catch (error) {
    console.warn('[Cache Recovery] sessionStorage 清理失败', error)
  }

  try {
    document.cookie.split(';').forEach((cookie) => {
      const cookieName = cookie.split('=')[0].trim()
      if (cookieName) {
        document.cookie = `${cookieName}=; Max-Age=0; path=/; SameSite=Lax`
      }
    })
  } catch (error) {
    console.warn('[Cache Recovery] 当前站点 Cookie 清理失败', error)
  }

  if ('caches' in window) {
    void window.caches
      .keys()
      .then((cacheNames) =>
        Promise.all(
          cacheNames.map((cacheName) => window.caches.delete(cacheName))
        )
      )
      .catch((error) => {
        console.warn('[Cache Recovery] Cache Storage 清理失败', error)
      })
  }
}

export function reloadWithCacheBuster() {
  const url = new URL(window.location.href)
  url.searchParams.set('_cache_reset', Date.now().toString())
  window.location.replace(url.toString())
}

/**
 * 使用原生捕获事件处理急救按钮，避免依赖已经异常的 Vue 响应式事件链。
 */
export function installEmergencyCacheRecovery() {
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target
      if (!(target instanceof Element)) return
      if (!target.closest(RECOVERY_BUTTON_SELECTOR)) return

      event.preventDefault()
      event.stopImmediatePropagation()

      const confirmed = window.confirm(
        '将清除全部页面缓存和登录信息，并重新加载到登录页。是否继续？'
      )
      if (!confirmed) return

      try {
        clearAppSiteData()
      } finally {
        reloadWithCacheBuster()
      }
    },
    true
  )
}
